/**
 * Removes the initial loading screen with a fade-out animation.
 * This function is used across multiple components to hide the HTML loading screen
 * that's rendered before Vue components mount.
 */
export function removeInitialLoading() {
  const initialLoading = document.getElementById('initial-loading')
  if (initialLoading) {
    initialLoading.style.transition = 'opacity 0.5s ease-out'
    initialLoading.style.opacity = '0'
    setTimeout(() => {
      initialLoading.remove()
    }, 500)
  }
}
